export default __webpack_public_path__ + "static/calendars-unite-mobile-f1f29d649e0ffff4992ba8e55c08352f.svg";